export class Attachment {
    constructor(name, attachmentData) {
        this.name = name;
        this.attachmentData = attachmentData;
    }
}
